import ServicePageLayout from '../../components/feature/ServicePageLayout';

const VerticalBlindsPage = () => {
  return (
    <ServicePageLayout
      blindType="Vertical Blinds"
      heroTitle="Vertical Blinds Northampton"
      heroSubtitle="Perfect for Patio Doors & Large Windows"
      introText="Upgrade your Northampton home with stylish vertical blinds. Ideal for patio doors, bi-fold doors and large windows, vertical blinds offer excellent light control and privacy. Available in a wide range of fabrics and colours, they're practical, durable and professionally installed by our expert team."
      heroImage="https://public.readdy.ai/ai/img_res/a7d882b6bfab1e6e076832295b11fdfa.jpg"
      features={[
        { icon: 'ri-door-open-line', title: 'Perfect for Patio Doors', desc: 'Designed specifically for sliding and bi-fold doors with smooth gliding operation' },
        { icon: 'ri-layout-column-line', title: 'Adjustable Light Control', desc: 'Rotate slats to control light and privacy or draw them fully open' },
        { icon: 'ri-t-shirt-line', title: 'Wide Fabric Range', desc: 'Choose from fabric, PVC or blackout materials in dozens of colours and textures' },
        { icon: 'ri-ruler-line', title: 'Made to Measure', desc: 'Custom-made to fit your exact window or door dimensions perfectly' },
        { icon: 'ri-shield-check-line', title: 'Durable & Long-Lasting', desc: 'Heavy-duty headrail and quality slats built to withstand daily use' },
        { icon: 'ri-paint-brush-line', title: 'Modern & Practical', desc: 'Clean, contemporary look that suits any interior style' },
      ]}
      pricePerBlind="£109"
      wholeHousePrice="£849"
      benefits={[
        { icon: 'ri-check-line', text: 'Perfect for patio doors' },
        { icon: 'ri-check-line', text: 'Made to measure' },
        { icon: 'ri-check-line', text: 'Wide fabric range' },
        { icon: 'ri-check-line', text: 'Professional installation' },
        { icon: 'ri-check-line', text: 'Unbeatable prices' },
      ]}
      faqs={[
        {
          question: 'Are vertical blinds good for patio doors?',
          answer: 'Yes! Vertical blinds are the ideal solution for patio doors, bi-fold doors and sliding doors. The vertical slats glide smoothly along the track, allowing easy access while providing excellent light control and privacy.'
        },
        {
          question: 'What materials are available for vertical blinds?',
          answer: 'We offer vertical blinds in fabric, PVC and blackout materials. Fabric options provide a soft, elegant look, while PVC is perfect for moisture-prone areas. Blackout vertical blinds are great for bedrooms and media rooms.'
        },
        {
          question: 'How do I clean vertical blinds?',
          answer: 'Vertical blinds are easy to maintain. Simply wipe PVC slats with a damp cloth, or use a vacuum cleaner with a brush attachment for fabric slats. Most fabric slats can also be removed for gentle washing if needed.'
        },
        {
          question: 'Can vertical blinds be fitted to large windows?',
          answer: 'Absolutely! Vertical blinds are perfect for large windows and wide openings. We custom-make each blind to your exact measurements, ensuring a perfect fit regardless of size.'
        },
        {
          question: 'Do vertical blinds provide good insulation?',
          answer: 'Yes, vertical blinds help reduce heat loss in winter and keep rooms cooler in summer. The vertical slats create an insulating barrier when closed, helping to improve your home\'s energy efficiency.'
        },
        {
          question: 'How long do vertical blinds last?',
          answer: 'With proper care, our high-quality vertical blinds can last 10-15 years or more. We use durable materials and robust mechanisms designed for daily use.'
        },
      ]}
      additionalContent={
        <section className="py-10 sm:py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
                  The Smart Choice for Large Openings
                </h3>
                <p className="text-gray-700 mb-6">
                  Vertical blinds remain one of the most practical and cost-effective solutions for patio doors and large windows across Northampton homes. Their vertical design makes them perfect for wide openings, while the adjustable slats give you complete control over light and privacy. Available in a huge range of colours and materials, vertical blinds complement any interior style from traditional to contemporary. Our professional installation ensures smooth operation and a perfect fit every time.
                </p>
              </div>
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20vertical%20blinds%20on%20patio%20doors%20in%20bright%20contemporary%20dining%20room%20with%20vertical%20fabric%20slats%20elegant%20interior%20natural%20light%20no%20people%20professional%20photography&width=800&height=600&seq=vertical-add-001&orientation=landscape"
                  alt="Vertical Blinds on Patio Doors"
                  className="w-full h-64 object-cover"
                />
              </div>
            </div>
          </div>
        </section>
      }
    />
  );
};

export default VerticalBlindsPage;